/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { INosKeyFactsViewProps } from './nos-key-facts';

export default (props: INosKeyFactsViewProps) => {
    return <section className='nos-key-facts'>{props.keyFacts}</section>;
};
